<template>
    <div>
        <div  class="navdh ">
            <ul class="clear"  v-for="item in list" :key="item.url">
                <!-- <p>{{item.text}}</p> -->
                <van-divider
                    :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
                    >
                    {{item.text}}
                </van-divider>
                <li class="fl" v-for="item1 in item.son" :key="item1.ming">
                    <!-- <a :href="item1.url"> -->
                    <div @click="open(item1)">
                        <svg class="icon" aria-hidden="true">
                            <use :xlink:href="item1.name"></use>
                        </svg>
                        <span>{{item1.ming}}</span>
                    </div>
                    <!-- </a> -->
                </li>
            </ul>            
        </div>
        <div class="kongbai"></div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Divider, Toast } from 'vant';
Vue.use(Divider);
export default {
    props:['list'],
    data(){
        return{
            userInfo:''
        }
    },
    mounted(){
    },
    methods:{
        open(item){
            console.log(item)
            if(localStorage.getItem("pad") == 'true'){
                // Toast("true")
                if(localStorage.getItem("userInfo")){
                    if(item.ming == '拍照搜题'){
                        this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
                        AndroidJs.openQuestion(this.userInfo.token)
                    } else if(item.ming == '学生自测'){
                        this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
                        console.log(this.userInfo.token,'pad')
                        AndroidJs.openTest(this.userInfo.token)
                    } else {
                        window.location.href = item.url
                    }
                } else {
                    console.log('2')
                    window.location.href = item.url
                }
            } else {
                console.log('3')
                window.location.href = item.url
            }
        }   
    }
}
</script>

<style scoped>
.navdh{
    padding: 0 15px;
}
.navdh ul{
    width: 100%;
}
.navdh ul li {
    width: 20%;
    text-align: center;
    margin-top: 4px;
}
.navdh ul li .icon{
    font-size: 32px;
    color: #4E8DF6;
}
.navdh ul li span{
    display: block;
    font-size: 12px;
    text-align: center;
    margin-top: 5px;
    min-height: 30px;
    overflow:hidden;
    white-space:nowrap;
}
.navdh ul p {
    margin-top: 4px;
    font-size: 14px;
}
.kongbai{
    height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/iconlist.vue